import { z } from "zod";
import { GetRequestStateDtoSchema } from "./GetRequestStateDto";

export const GetRequestsStatesInputSchema = z.object({
    requestsStates: z.array(GetRequestStateDtoSchema),
});

export type GetRequestsStatesInput = z.infer<typeof GetRequestsStatesInputSchema>;
